/**
  Onsen UI Navigatorオブジェクトによってページ遷移する
  Rooterの役割
  ページ遷移の定義はここにまとめる
*/
import Vue from 'vue'
import BlankPage from "../../pages/BlankPage";
import NotfoundPage from "../../pages/NotfoundPage";
import SinglePage from "../../pages/SinglePage";
//import SinglePage from "../../pages/MonoPage";
import MenuPage from "../../pages/MenuPage";
import OrderPage from "../../pages/OrderPage";
import OrderHistoryPage from "../../pages/OrderHistoryPage";
import StartPage from "../../pages/StartPage";
import LineFriendPage from "../../pages/LineFriendPage";
import ItemSelectPage from "../../pages/ItemSelectPage";
import MenuListPage from "../../pages/MenuListPage";

const state = {
  home_page_index:0,
  pageStack: [BlankPage],
  currentMenu: "",
  open: false,
  options: {},
  propsData: {}
};

const getters = {
  currentMenu: state => state.currentMenu,
  pageStack: state => state.pageStack,
  isMenuOpened: state => state.open,
  propsData: state => state.propsData
};

// actions
const actions = {
  navigatePage({ commit, dispatch,state }, param) {
    dispatch('SetCurrentSubmenu',null) //移動時にカレントの放題メニューオブジェクトクリア
    commit("toggle", false);
    if (param.menu == null) {
      commit("pushPage", { menu: param, data: { mode: "back" } });
    } else {
      commit("pushPage", param);
    }
  },
  navigateWPPage({ commit, dispatch,state }, page_id) {
    dispatch('SetCurrentSubmenu',null) //移動時にカレントの放題メニューオブジェクトクリア
    if(page_id=='menu_top'){
      
      //トップページの場合
      dispatch('GetTopPage')
      .then(result=>{
        if(result.length>0){
          if(result[0].page_type==1){
            //めくりページテンプレートへ遷移
            commit("toggle", false);
            commit("pushPage",{ menu:'menu', data: result[0] });
          }else{
            /*
            if(page_id=='menu_top'){
              result[0]['mode']="normal"
            }
            */
            commit("toggle", false);
            commit("pushPage",{ menu:'home', data: result[0] });
          }
        }else{
          dispatch('showErrorMessage','ページがありませんでした')
        }
      })
      .catch(()=>{
        dispatch('showErrorMessage','ページが表示できません')
      })
    }else{
      
      dispatch('GetWPPage',page_id)
      .then(result=>{
        
        if(result.length>0){
          //時間制限品で、ページIDがカンマ区切りで複数ある場合はめくりテンプレートへ
          if(result[0].page_type==2 && result[0].page_group_id!=''){
            //めくりページテンプレートへ遷移
            commit("toggle", false);
            result[0]['mode']='back'
            commit("pushPage",{ menu:'menu', data: result[0] });
          }else{
            if(result[0].page_type==1){
              //めくりページテンプレートへ遷移
              commit("toggle", false);
              result[0]['mode']='back'
              commit("pushPage",{ menu:'menu', data: result[0] });
            }else{
              /*
              if(page_id=='menu_top'){
                result[0]['mode']="normal"
              }
              */
              commit("toggle", false);
              commit("pushPage",{ menu:'home', data: result[0] });
            }
          }
          
        }else{
          dispatch('showErrorMessage','ページがありませんでした')
        }
      })
      .catch(()=>{
        dispatch('showErrorMessage','ページが表示できません')
      })
    }
    
  },

  navigateLink({ commit, dispatch,state }, param){
    
    var item=param.item
    var back_flag=param.back_flag==undefined?false:param.back_flag
    
    if(item.type=='page-link'){
      //WPページへ遷移
      dispatch('navigateWPPage',item.code)
      
    }else{
      //商品詳細ページへ遷移
      //欠品商品以外だけ遷移する
      if(item.code==''){
        this.showErrorMessage('商品コードが設定されていません')
        return
      }
     
      if(item.goods_status==1 && (item.goods_status2==0 || item.goods_status2==2 || item.goods_status2==12 || item.goods_status2==22)){
      
        //商品情報を取得してからページ遷移
        var item_array=item.code.split(',');
        if(item_array.length>1){
          /**複数商品 */
          var order_items=[]
          for(var i=0;i<item_array.length;i++){
            order_items.push({
              code:item_array[i]
            })
          }
          dispatch('setLoadingScreenVisibility',true)
          dispatch('GetGoodsStatusWidthImage',order_items)
          .then(result=>{
            dispatch('navigatePage',{menu:'item_select',  data:{mode:'back',items:item_array}})
            dispatch('setLoadingScreenVisibility',false)
          })
          .catch(error=>{
            dispatch('setLoadingScreenVisibility',false)
          })

          
        }else{
          /**１商品 */
          dispatch('setLoadingScreenVisibility',true)
          dispatch('GetGoodsInfo',item.code)
          .then(result=>{
            dispatch('navigateOrderPage',{menu:'order', code:item.code, data:{mode:'back', item_info:result, back_flag:back_flag}})
            dispatch('setLoadingScreenVisibility',false)
          })
          .catch(()=>{
            dispatch('setLoadingScreenVisibility',false)
          })
        }
      }
    }
  },

  navigateOrderPage({ commit, state }, param) {
    commit("toggle", false);
    commit("pushPage",param);
  },

  openMenu({ commit }) {
    commit("toggle", true);
  },
  closeMenu({ commit }) {
    commit("toggle", false);
  },
  toggleMenu({ getters, commit, dispatch }) {
    if (getters.isMenuOpened === false) {
      // メッセージ未読を取得
      dispatch("getUnreadCount");
    }
    commit("toggle");
  },
  popPage({ commit }) {
    commit("popPage");
  }
};

// mutations
const mutations = {
  /**
    グローバルメニューを開閉する
  */
  toggle(state, shouldOpen) {
    if (typeof shouldOpen === "boolean") {
      state.open = shouldOpen;
    } else {
      state.open = !state.open;
    }
  },
  /**
    NavigatorにページをPop(１つ前に戻る)する
  */
  popPage(state) {
    state.pageStack.pop();
  },
  /**
    グローバルナビやボトムツールバーなどから呼ばれる
    Navigatorを使ってページ遷移する
    state.pageStackオブジェクトはApp.vueから唯一のNavigationオブジェクトを渡される
  */
  pushPage(state, param) {
    // dataは子コンポーネントのprosにそのまま渡される
    const menu = param.menu;
    const props = param.data;
    
    if(!props.mode){
      props.mode='normal'
    }
    const animation = new Map([
      ["normal", "fade"],
      ["back", "slide"],
      ["close", "lift"]
    ]).get(props.mode);
    let page;

    switch (menu) {
      case "blank":
        page = BlankPage;
        break;
      case "notfound":
          page = NotfoundPage;
          break;
      case "home":
        page = SinglePage;
        break;
      case "single":
        page = SinglePage;
        break;
      case "menu":
        page = MenuPage;
        break;
      case "order":
        page = OrderPage;
        break;
      case "history":
        page = OrderHistoryPage;
        break;
      case "start":
        page = StartPage;
        break;
      case "line_friend":
        page = LineFriendPage;
        break;
      case "item_select":
        page = ItemSelectPage;
        break;
      case "menu_list":
        page = MenuListPage;
        break;
      default:
    }
    // ページ遷移
    /*
    if (props.mode === "normal") {
      state.currentMenu = menu;
      state.pageStack.pop();
    }*/
    
    /*
    if(menu=='home'){
      state.home_page_index=state.pageStack.length
    }else{
      //HOMEまでのNavigateヒストリーは切り捨て
      state.pageStack=state.pageStack.slice(state.home_page_index)
    }
    */
    

    

    /*
    const instance_page = Vue.util.extend(
      {},
      page
    ) */
      
    //page.name=param.data.page_id
    state.pageStack.push({
      extends: page,
      onsNavigatorProps:{
        propData:param.data
      },
      onsNavigatorOptions: {
        animation: animation
      }
      // propsData: props
    });
    state.propsData = props;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/navigator.js